import EditableChipList from './EditableChipList';

export default EditableChipList;